import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TramiteSuperfinancieraDto } from '../../../../dto/tramites/tramite-superfinanciera.dto';
import { AnexoPrecargaResponseDto } from '../../../../dto/anexo/anexo-tramite.dto';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Constants } from '../../../../constants/constants';
import { ListaValorRequestDto, ListaValorResponseDto } from '../../../../dto/tramites/lista_valor.dto';
import { ListaValorService } from '../../sic/proteccion-al-consumidor/services/lista-valor.service';
import { TranslateService } from '@ngx-translate/core';
import { CargueArchivosTramiteService } from '../../../util/archivos-tramite/services/cargue-archivos-tramite.service';
import { FormField } from '../../../../dto/util/form-field';
import { ArchivoItemDto } from '../../../util/archivos-tramite/dto/ArchivoItemDto';
import { combineLatest } from 'rxjs';
import { PersonaLoginDTO } from '../../../../dto/util/persona.dto';
import { TipoAnexoTipoTramiteDto } from '../../../util/archivos-tramite/dto/tipo-anexo-tipo-tramite.dto';
import { AlertaModalService } from '../../../../services/util/alerta-modal.service';

@Component({
  selector: 'app-sfc-reclamo',
  templateUrl: './sfc-reclamo.component.html',
  styleUrl: './sfc-reclamo.component.scss'
})
export class SfcReclamoComponent implements OnInit, OnChanges {
  @Input() tramiteSfc?: TramiteSuperfinancieraDto;
  @Input() archivosPreCargados?: AnexoPrecargaResponseDto[];
  archivoPrecargadoPoderJudicial?: AnexoPrecargaResponseDto;
  @Output() continuar = new EventEmitter<{
    tramite: TramiteSuperfinancieraDto;
    formValid: boolean;
    event: Event;
    anexos?: AnexoPrecargaResponseDto[];

  }>();
  @Output() guardarSinEnviar = new EventEmitter<{
    tramite: TramiteSuperfinancieraDto;
    formValid: boolean;
    event: Event;
    anexos?: AnexoPrecargaResponseDto[];

  }>();
  @Input() volver: boolean = false;
  @Output() reclamoEmit = new EventEmitter<{
    formReclamo: FormGroup;
  }>();

  entidadId: number = Constants.TRAMITES.SUPER_FINANCIERA;

  formReclamoDirecto!: FormGroup;
  listaTipoReclamacion: ListaValorResponseDto[] = [];
  maxDay?: string;
  // Multilenguaje
  sfcText: any = {}
  comunText: any = {}
  alertaText: any = {};

  // Fechas
  fechaReclamo: unknown;
  fechaRespuesta: unknown;
  mostrarComponente = false;
  dataUsuario: PersonaLoginDTO;
  enviarDocumentos = false;
  enviar = false;
  idsFilesPasoReclamo: TipoAnexoTipoTramiteDto[] = [];
  archivosCargados: ArchivoItemDto[] = [];
  pesoTotalArchivosMB: string = '0.00';
  nombreTramite = '';

  festivos: string[] = [];
  constructor(
    private readonly fb: FormBuilder,
    private readonly listaValorService: ListaValorService,
    private readonly translate: TranslateService,
    private readonly cargueArchivosTramiteService: CargueArchivosTramiteService,
    private readonly alertaModalService: AlertaModalService
  ) {
    this.dataUsuario = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
    );

    this.festivos = this.JSON.parse(
      sessionStorage.getItem(Constants.LISTA_FESTIVOS)!
    );
  }

  formFieldsReclamoDirecto: FormField[] = [];

  tipoReclamacion = '';

  recibioRespuesta = '';

  tieneArchivosCargados = false;


  buildForms() {
    this.formFieldsReclamoDirecto = [
      {
        name: 'subTitle',
        isSubtitle: true,
        required: false,
        subtitleText: this.sfcText['sfc-procon']['texto-informativo'],
        label: '',
        type: 'text',
        visible: true,
        isParrafo: true,
      },
      {
        name: 'tipoReclamacion',
        label: this.sfcText['tramite-sic-procon']['atencion-reclamacion'],
        type: 'select',
        required: true,
        options: [],
        width: '12',
        visible: true,
        errorMessages: { required: this.sfcText['seleccione-opcion'] },
      },
      {
        name: 'fechaReclamo',
        label: this.sfcText['tramite-sic-procon']['label-fecha-reclamo'],
        type: 'date',
        required: false,
        validation: [this.fechaValidator(this.festivos)],
        width: '12',
        visible: true,
        isMaxDate: true,
        errorMessages: {
          required: this.sfcText['tramite-sic-procon']['seleccione-fecha'],
          fueraDeRango:
            this.sfcText['tramite-sic-procon']['dar-cumplimiento'],
          invalidRange:
            this.comunText['fecha-invalida'],
        },
      },
      {
        name: 'canalReclamo',
        label: this.sfcText['sfc-procon']['canal-reclamo'],
        placeholder: this.sfcText['sfc-procon']['detalle-hechos-placeholder'],
        type: 'textarea',
        width: '12',
        visible: true,
        required: false,
        validation: [Validators.maxLength(100)],
        errorMessages: {
          required: this.sfcText['sfc-procon']['canal-required'],
          maxlength: this.sfcText['sfc-procon']['detalle-inconformidad-producto-maxlength'],
        },
      },
      {
        name: 'recibioRespuesta',
        label: this.sfcText['tramite-sic-procon']['recibio-respuesta'],
        type: 'select',
        required: true,
        options: [
          { Id: 'S', Nombre: this.comunText['opcion-si'] },
          { Id: 'N', Nombre: this.comunText['opcion-no'] },
        ],
        width: '12',
        visible: true,
        errorMessages: { required: this.sfcText['seleccione-opcion'] },
      },
      // {
      //   name: 'manifiesto',
      //   label: '',
      //   type: 'checkbox',
      //   options: [
      //     {
      //       Id: 1,
      //       Nombre: this.sfcText['tramite-sic-procon']['juramento'],
      //     },
      //   ],
      //   width: '12',
      //   visible: true,
      //   errorMessages: { required: this.sfcText['seleccione-opcion'] },
      //   dependsOn: 'recibioRespuesta',
      //   visibilityCondition: value => value == 'N',
      // },
      {
        name: 'fechaRespuesta',
        label: this.sfcText['tramite-sic-procon']['fecha-entrega-respuesta'],
        type: 'date',
        required: false,
        validation: [this.fechaValidator(this.festivos)],
        width: '12',
        visible: true,
        isMaxDate: true,
        errorMessages: {
          required: this.sfcText['tramite-sic-procon']['seleccione-fecha'],
          invalidField:
            this.sfcText['tramite-sic-procon']['fecha-respuesta-invalida'],
          fueraDeRango:
            this.sfcText['tramite-sic-procon']['dar-cumplimiento'],
          invalidRange:
            this.comunText['fecha-invalida'],
        },
        dependsOn: 'recibioRespuesta',
        visibilityCondition: value => value == 'S',
      },
    ];
  }

  ngOnInit() {
    this.nombreTramite = JSON.parse(
      sessionStorage.getItem(Constants.TRAMITE_SELECCIONADO)!
    );
    combineLatest({
      tramites: this.translate.stream('tramites'),
      comun: this.translate.stream('comun-label'),
      alertas: this.translate.stream('alertas'),
    }).subscribe(({ tramites, comun, alertas }) => {
      // Asignar traducciones a variables
      this.sfcText = tramites;
      this.comunText = comun;
      this.alertaText = alertas;
      // Construir formularios después de cargar traducciones
      this.buildForms();
    });
    this.formReclamoDirecto = this.fb.group({
    });
    this.fechaMaxima();
    this.listaValor();
  }

  ngOnChanges(changes: SimpleChanges) {
    const tramite: TramiteSuperfinancieraDto =
      changes['tramiteSfc']?.currentValue;

    //Si el tramite cambia, se seta toda la informacion del mismo
    if (tramite !== undefined) {
      this.archivosPreCargados = tramite.anexos;
      if (tramite.tipoReclamacion !== undefined) {
        this.formFieldsReclamoDirecto = this.formFieldsReclamoDirecto.map(
          field => {
            if (field.name === 'tipoReclamacion') {
              field.value = tramite.tipoReclamacion?.id ?? +tramite.tipoReclamacion!;
            }
            if (field.name === 'fechaReclamo') {
              field.value = tramite!.fechaReclamo ? this.setDateValue(
                tramite!.fechaReclamo!.toString()
              ) : '';
            }
            if (field.name === 'canalReclamo') {
              field.value = tramite.canalRespuesta;
            }
            if (field.name === 'recibioRespuesta') {
              field.value = `${tramite.recibioRespuesta ? 'S' : 'N'}`;
            }
            // if (field.name === 'manifiesto') {
            //   this.setManifiesto('manifiesto', tramite?.recibioRespuesta!)
            // }
            if (
              field.name === 'fechaRespuesta' &&
              tramite &&
              tramite.fechaRespuesta
            ) {
              field.value = this.setDateValue(
                tramite!.fechaRespuesta!.toString()
              );
            }
            return field;
          }
        );

        this.formReclamoDirecto.patchValue({
          tipoReclamacion: tramite.tipoReclamacion?.id,
          fechaReclamo: tramite.fechaReclamo,
          recibioRespuesta: tramite.recibioRespuesta ? 'S' : 'N',
          // respuestaReclamoDirecto: tramite.respuestaReclamoDirecto,
          fechaRespuesta: tramite.fechaRespuesta,
          // manifiesto: true,
        });
      }
    }
  }

  fechaValidator(festivos: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null; // No validar si no hay valor

      const fechaReclamo = new Date(control.value);
      const fechaMin = new Date();
      let diasHabiles = Constants.DIAS_HABILES;

      while (diasHabiles > 0) {
        fechaMin.setDate(fechaMin.getDate() - 1);
        const fechaStr = fechaMin.toISOString().split('T')[0];
        // Si es sábado (6), domingo (0) o festivo no cuenta como día hábil
        if (fechaMin.getDay() !== 0 && fechaMin.getDay() !== 6 && !festivos.includes(fechaStr)) {
          diasHabiles--;
        }
      }

      if (fechaReclamo > fechaMin) {
        return { fueraDeRango: true };
      }

      return null;
    };
  }

  setManifiesto(controlName: string, value: boolean) {
    this.formFieldsReclamoDirecto.forEach(field => {
      if (field.name === controlName) {
        if (value) {
          field.value = undefined;
        }
      }
    });
  }


  listaValor() {
    this.listaValorService.lista('SIC_TIPO_RECLAMACION').subscribe(data => {
      const response = data as ListaValorResponseDto[];
      this.listaTipoReclamacion = response;

      this.formFieldsReclamoDirecto = this.formFieldsReclamoDirecto.map(
        field => {
          if (field.name === 'tipoReclamacion') {
            field.options = response.map((item: ListaValorResponseDto) => ({
              Id: item.Id!,
              Nombre: item.Valor!,
            }));
          }
          return field;
        }
      );
    });
  }

  validarFormulario(formGroup: FormGroup) {
    this.formReclamoDirecto = formGroup;
    const tipoReclamacionSeleccionado = this.listaTipoReclamacion.find(
      item => item.Id === this.formReclamoDirecto.value['tipoReclamacion']
    );
    if (tipoReclamacionSeleccionado?.Codigo === 'TR_E') {
      setTimeout(() => {
        this.tipoReclamacion = 'Escrita';
      }, 10);

      this.setFieldForm(this.formFieldsReclamoDirecto, 'canalReclamo', false);
    } else if (tipoReclamacionSeleccionado?.Codigo === 'TR_V') {
      setTimeout(() => {
        this.tipoReclamacion = 'Verbal';
        this.tieneArchivosCargados = true;
      }, 10);
      this.setFieldForm(this.formFieldsReclamoDirecto, 'canalReclamo', true);

    }
    if (formGroup?.get('fechaReclamo')?.value) {
      // Se convierte el valor de fechaReclamo a string y luego a Date
      const fechaReclamoValue = formGroup.controls['fechaReclamo'].value;
      if (typeof fechaReclamoValue === 'string') {
        this.fechaReclamo = new Date(fechaReclamoValue);
        if (this.fechaReclamo instanceof Date) {
          const fechaMax = new Date(this.maxDay!);
          if (this.fechaReclamo > fechaMax) {
            formGroup?.get('fechaReclamo')?.setErrors({
              'invalid-date-range': true,
            });
          }
        }
      }
    }
    if (formGroup?.get('fechaRespuesta')?.value) {
      // Se convierte el valor de fechaRespuesta a string y luego a Date
      const fechaRespuestaValue = formGroup.get('fechaRespuesta')?.value;
      if (typeof fechaRespuestaValue === 'string') {
        this.fechaRespuesta = new Date(fechaRespuestaValue);
        // Comparar las fechas
        if (this.fechaReclamo instanceof Date && this.fechaRespuesta instanceof Date) {
          if (this.fechaRespuesta < this.fechaReclamo) {
            formGroup.controls['fechaRespuesta'].setErrors({
              'is-invalid': true,
            });
          }
          const fechaMax = new Date(this.maxDay!);
          if (this.fechaRespuesta > fechaMax) {
            formGroup.controls['fechaRespuesta'].setErrors({
              'invalid-date-range': true,
            });
          }
        }
      }
    }
    if (formGroup?.get('recibioRespuesta')?.value) {
      this.actualizarValidaciones(formGroup.get('recibioRespuesta')?.value);
    }
    if (formGroup?.valid) {
      this.reclamoEmit.emit({
        formReclamo: this.formReclamoDirecto,
      });
    }
  }

  validarCampos(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    if (event.controlName === 'fechaReclamo') {
      // Se convierte el valor de fechaReclamo a string y luego a Date
      const fechaReclamoValue = event.form.controls['fechaReclamo'].value;
      if (typeof fechaReclamoValue === 'string') {
        this.fechaReclamo = new Date(fechaReclamoValue);
      }
    }
    if (event.controlName === 'fechaRespuesta') {
      // Se convierte el valor de fechaRespuesta a string y luego a Date
      const fechaRespuestaValue = event.form.controls['fechaRespuesta'].value;
      if (typeof fechaRespuestaValue === 'string') {
        this.fechaRespuesta = new Date(fechaRespuestaValue);
        // Comparar las fechas
        if (this.fechaReclamo instanceof Date && this.fechaRespuesta instanceof Date) {
          if (this.fechaRespuesta < this.fechaReclamo) {
            event.form.controls['fechaRespuesta'].setErrors({
              'is-invalid': true,
            });
          }
          const fechaMax = new Date(this.maxDay!);
          if (this.fechaRespuesta > fechaMax) {
            event.form.controls['fechaRespuesta'].setErrors({
              'invalid-date-range': true,
            });
          }
        }
      }
    }
  }

  setFieldForm(form: FormField[], nameField: string, flag: boolean) {
    form.forEach(field => {
      if (field.name == nameField) {
        field.required = flag;
      }
    })
    if (flag) {
      this.formReclamoDirecto.get(nameField)?.addValidators(Validators.required);
    } else {
      this.formReclamoDirecto.get(nameField)?.removeValidators(Validators.required);
    }
    this.formReclamoDirecto.get(nameField)?.updateValueAndValidity();
  }


  actualizarValidaciones(valorSeleccion: string | unknown) {
    this.recibioRespuesta = valorSeleccion as string;

    if (valorSeleccion != 'S') {
      this.formReclamoDirecto.get('fechaRespuesta')?.clearValidators();
      // this.formFieldsReclamoDirecto.forEach(field => {
      //   if (field.name === 'fechaRespuesta') {
      //     field.validation = [this.fechaValidator];
      //   }
      // });
    } else {
      this.formReclamoDirecto.get('fechaRespuesta')?.clearValidators();
      this.formReclamoDirecto.get('fechaRespuesta')?.addValidators([this.fechaValidator(this.festivos), Validators.required]);
      this.formFieldsReclamoDirecto.forEach(field => {
        if (field.name === 'fechaRespuesta') {
          field.validation = [this.fechaValidator(this.festivos)];
          field.required = true;
        }
      });
    }
    this.formReclamoDirecto.get('fechaRespuesta')?.updateValueAndValidity();

  }

  pasarANotificaciones(event: Event, guardarSinEnviar: boolean) {

    if (this.formReclamoDirecto.invalid) {

      this.formReclamoDirecto.markAllAsTouched();

      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );

      return;
    }

    if (!guardarSinEnviar) {
      if (!this.validarDocumentosObligatorios()) {
        this.alertaModalService.error(
          this.alertaText['error'],
          this.alertaText['archivos_obligatorios']
        );

        return;
      }
    }
    const item = this.listaTipoReclamacion.find(
      item => item.Id === this.formReclamoDirecto.value['tipoReclamacion']
    );

    const listaValor: ListaValorRequestDto = {
      valor: item?.Valor,
      estado: item?.Estado,
      nombreLista: item?.Nombre_Lista,
      codigo: item?.Codigo,
      otroValor: item?.Otro_valor,
      idExterno: item?.Id_Externo,
      id: item?.Id,
    };

    const tramite: TramiteSuperfinancieraDto = {
      id: this.tramiteSfc?.id,
      paso: 5,
      tipoReclamacion: listaValor,
      fechaReclamo: this.formReclamoDirecto.value['fechaReclamo'],
      recibioRespuesta:
        this.formReclamoDirecto.value['recibioRespuesta'] === 'S',
      canalRespuesta: this.formReclamoDirecto.value['canalReclamo'],
      fechaRespuesta: this.formReclamoDirecto.value['fechaRespuesta'],
      idTipoTramite: this.tramiteSfc?.idTipoTramite ?? Constants.TRAMITES.SUPER_FINANCIERA,
      usuario: { id: this.tramiteSfc?.data?.Id_Creador ?? this.dataUsuario.idUsuario },
    };

    const formValid = this.formReclamoDirecto.valid;

    if (!guardarSinEnviar) {
      let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
      if (paso) {
        sessionStorage.setItem(Constants.PASOS, JSON.stringify(6));
      }
      this.enviar = false;
      this.continuar.emit({
        tramite: tramite,
        formValid,
        event: event,
      });
    } else {
      this.guardarSinEnviar.emit({
        tramite: tramite,
        formValid,
        event: event,
      });
    }
    this.enviarDocumentos = true;
  }

  atras() {
    let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso) {
      paso--;
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(paso));
    }
  }

  fechaMaxima() {
    const today: Date = new Date();
    const year: number = today.getFullYear();
    const month: string = String(today.getMonth() + 1).padStart(2, '0');
    const day: string = String(today.getDate()).padStart(2, '0');

    this.maxDay = `${year}-${month}-${day}`;
  }


  setDateValue(dateString: string): string | undefined {
    if (!dateString) return; // Manejo de caso nulo o vacío
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.warn(`Fecha inválida: ${dateString}`);
      return;
    } else {
      const formattedDate = date.toISOString().split('T')[0]; // Formato yyyy-MM-dd
      return formattedDate;
    }
  }

  // Archivos

  subirArchivo(resultado: boolean) {
    this.enviarDocumentos = false;
  }

  getFilesPrecargadosByPaso(paso: number): AnexoPrecargaResponseDto[] {
    return this.archivosPreCargados?.filter(
      elemento => elemento.tipoAnexoTipoTramite.orden === paso
    ) || [];
  }

  getFileRequeridos(evento: { archivos: TipoAnexoTipoTramiteDto[]; paso: number }) {
    if (evento.paso == 5) {
      this.idsFilesPasoReclamo = this.searchRequired(evento.archivos);
    }
  }

  searchRequired(archivos: TipoAnexoTipoTramiteDto[]) {
    archivos = archivos.filter(
      (anexo: any) => anexo.requerido === true
    );
    return archivos;
  }

  validarArchivosCargados(archivos: ArchivoItemDto[], paso: number) {
    if (paso == 5) {
      this.archivosCargados = archivos;
    }
    const anexosRequeridosIds = this.idsFilesPasoReclamo.map(
      (anexo: any) => anexo.id
    );
    const totalBytes = this.archivosCargados.reduce(
      (total, archivo) => total + archivo.files.reduce((sum, file) => sum + file.size, 0),
      0
    );
    this.pesoTotalArchivosMB = (totalBytes / (1024 * 1024)).toFixed(2);

    return this.isEmptyAnexo(this.archivosCargados, anexosRequeridosIds);

  }

  get pesoArchivos(): string {
    return this.pesoTotalArchivosMB;
  }

  isEmptyAnexo(archivosCargados: ArchivoItemDto[], ids: number[]): boolean {
    let requeridosFull: number = 0;
    let cantidadRequeridos: number = ids.length;
    ids.forEach((elemento: number) => {
      archivosCargados.forEach((anexo: ArchivoItemDto) => {
        if (elemento == anexo.item.id) {
          if (anexo.files.length > 0) {
            requeridosFull++;
          } else {
            requeridosFull--;
          }
        }
      });
    });
    return requeridosFull === cantidadRequeridos;
  }

  validarDocumentosObligatorios(): boolean {
    const anexosRequeridosIds = this.idsFilesPasoReclamo.map(
      (anexo: any) => anexo.id
    );
    return this.isEmptyAnexo(this.archivosCargados, anexosRequeridosIds);
  }

  protected readonly JSON = JSON;

  mostrarCamposRequeridos(formGroup: FormGroup) {
    const camposRequeridos = Object.keys(formGroup.controls).filter(
      controlName =>
        formGroup.get(controlName)?.hasValidator(Validators.required)
    );
    return camposRequeridos;
  }

  validarPaso(): boolean {
    if (this.formReclamoDirecto.valid && this.validarDocumentosObligatorios()) {
      return false;
    } else {
      return true;
    }
  }
}
